/**
 * Maps driver enum values to human-readable labels for display in badges
 */

const DRIVER_LABELS = {
    // Positive drivers
    "waterfront_frontage_prime": "Waterfront",
    "waterfront_frontage_secondary": "Waterfront",
    "waterfront_view_only": "Water view",
    "golf_frontage_prime": "Golf frontage",
    "golf_frontage_prime_down_the_hole": "Golf frontage",
    "golf_frontage_nonprime": "Golf frontage",
    "adjacent_park_or_greenbelt": "Park adjacent",
    "nearby_park_or_greenbelt": "Near park",
    "broad_mountain_view": "Mountain view",
    "partial_mountain_view": "Mountain view",
    "backs_to_natural_open_space": "Open space",
    "extra_lot_privacy_or_buffer": "Extra privacy",
    "cul_de_sac_setting": "Cul-de-sac",

    // Negative drivers
    "separation_crosses_major_highway_artery": "Highway",
    "attached_cluster_micro_lot": "Cluster home",
    "adjacent_heavy_commercial_or_parking": "Commercial area",
    "adjacent_industrial_or_utility_site": "Industrial area",
    "overhead_high_voltage_corridor": "Power lines",
    "terrain_hazard_slope_or_cliff": "Terrain hazard",
    "noise_rating_high": "High noise",
    "separation_crosses_navigable_river_or_creek": "River separation",
    "flood_control_basin_or_water_hazard": "Flood basin",
    "backs_to_engineered_canal_or_drainage": "Canal",
    "nearby_ag_or_industrial_operations": "Industrial nearby",
    "separation_crosses_active_rail_line": "Rail line",
    "visual_blight_billboards_or_wires": "Visual blight",
    "flag_lot_setting": "Flag lot",
    "access_constraint_shared_easement": "Shared drive",
    "access_constraint_flag_lot_or_easement": "Access issue", // legacy — kept for historic Firestore docs
    "access_constraint_limited_parking_or_grade": "Parking issue",
    "t_intersection_head_on": "T-intersection",
    "backs_to_multifamily": "Multifamily"
};

/**
 * Get human-readable label for a driver enum value
 * @param {string} driver - The driver enum value
 * @returns {string|null} - Human-readable label or null if not found
 */
export const getDriverLabel = (driver) => {
    if (!driver || typeof driver !== 'string') {
        return null;
    }
    return DRIVER_LABELS[driver] || null;
};

/**
 * Get human-readable labels for an array of drivers
 * @param {string[]} drivers - Array of driver enum values
 * @returns {string[]} - Array of human-readable labels
 */
export const getDriverLabels = (drivers) => {
    if (!Array.isArray(drivers)) {
        return [];
    }
    return drivers.map(getDriverLabel).filter(Boolean);
};

